import StandardError from './Standard'

class NotFoundError extends StandardError {
  constructor(message = 'Not found') {
    super(message)
    this.status = 404
  }
}

export default NotFoundError
